export default __webpack_public_path__ + "static/assets/SL-X-purple-light.33d8a3f2.png";